import { render, staticRenderFns } from "./functionSonSon.vue?vue&type=template&id=20377397&scoped=true&"
import script from "./functionSonSon.vue?vue&type=script&lang=js&"
export * from "./functionSonSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20377397",
  null
  
)

export default component.exports